let appVersion = '';

export const getAppVersion = () => appVersion;

export const setAppVersion = (version: string) => appVersion = version;
